module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/05_illustrations#ill",
      "id": "rill"
    }
  }, [_c('em', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_readers#readers",
      "id": "rreaders"
    }
  }, [_c('em', [_vm._v("A Note to Readers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07_introduction#intro",
      "id": "rintro"
    }
  }, [_c('em', [_vm._v("Introduction: The UFO Syndrome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch01#ch1",
      "id": "rch1"
    }
  }, [_vm._v("1. Extravagant Fiction Today – Cold Fact Tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/09_ch02#ch2",
      "id": "rch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. I "), _c('em', [_vm._v("Know")]), _vm._v(" What I Saw")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_ch03#ch3",
      "id": "rch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Purple Lights and March Foolishness")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_ch04#ch4",
      "id": "rch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The James Bond Department")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch05#ch5",
      "id": "rch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Demand the Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch06#ch6",
      "id": "rch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Crashed Saucer Syndrome")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch07#ch7",
      "id": "rch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Cosmic Voices")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch08#ch8",
      "id": "rch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. They Are Coming to Take Me Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch09#ch9",
      "id": "rch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Angels or Demons?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch10#ch10",
      "id": "rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Take Me to Your Leading Scholars!")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/18_conclusion#con",
      "id": "rcon",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conclusion: In the Eye of the Beholder")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_glossary#gloss",
      "id": "rgloss",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_notes#notes",
      "id": "rnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes and References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_bibliography#biblio",
      "id": "rbiblio",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_index#index",
      "id": "rindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c3e8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 66
// module chunks = 0